// Mutations
export const SET_USER_PROFILE = 'SET_USER_PROFILE';

// Actions
export const INIT_USER_PROFILE = 'INIT_USER_PROFILE';
export const CHANGE_NAME = 'CHANGE_NAME';
